import { FetchMessageSettingsActionTypes, UpdateMessageSettingsActionTypes, ClearMessageSettingsActionTypes } from '../actions/MessageSettingsActions';
import { handleActions } from 'flux-actions';
import MessageSettings from '../records/MessageSettings';
const initialState = new MessageSettings();
export default handleActions({
  [FetchMessageSettingsActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const data = action.payload.data;
    return new MessageSettings(data);
  },
  [UpdateMessageSettingsActionTypes.SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const props = action.payload.props;
    return new MessageSettings(props);
  },
  [ClearMessageSettingsActionTypes.SUCCESS]() {
    return initialState;
  }
}, initialState);